document.addEventListener("DOMContentLoaded", function () {
  var freeShippingMessage = document.getElementById("free-shipping-message");
  var currentUrl = window.location.pathname;

  // Get prices exposed via Liquid
  var salePrice = parseFloat(window.productPrice);
  var regularPrice = parseFloat(window.compareAtPrice);

  // Determine the active price (sale price takes precedence if available)
  var activePrice = salePrice > 0 ? salePrice : regularPrice;

  // Check conditions for displaying the message
  if (activePrice >= 100 && !currentUrl.includes("/en-eu") && !currentUrl.includes("/en-int")) {
    freeShippingMessage.style.display = "block"; // Show the free shipping message
  }
});
